import React, {useEffect } from 'react';
import Teammate from './Teammate';



export default function Team(props) {
    document.title="KinowAVE-"+props.title;


    // to move of the window
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


    

    const teamMembers = [
        {
          id: 1,
          name: "Brathikan V M",
          role: "Co-Founder & Simulation Engineer",
          initialImg: "./images/Brathikan V M(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/brathikan/"
        },
        {
          id: 2,
          name: "Janarthanan Venkatachalam",
          role: "Co-Founder & Design Engineer",
          initialImg: "./images/Janarthananan(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/connectwithjana/"
        },
        {
          id: 3,
          name: "Sivakeerthana S",
          role: "Control System Intern",
          initialImg: "./images/Sivakeerthana S(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/sivakeerthana/"
        },
        {
          id: 4,
          name: "Harini R",
          role: "Product Management Intern",
          initialImg: "./images/Harini R(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/harini-ramesh-0483ab234/"
        },
        {
          id: 5,
          name: "Krishnan K",
          role: "System Fabrication Intern",
          initialImg: "./images/Krishnan K(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/krisnan/"
        },
        {
          id: 6,
          name: "Kalanithi S",
          role: "Simulation Intern",
          initialImg: "./images/Kalanithi S(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/kalanithi-s-5167a9281/"
        },
        {
          id: 7,
          name: "Dr.Sreeharan",
          role: "Manufacturing and Welding Expert",
          initialImg: "./images/Dr.Srihaaran(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/dr-sreeharan-b-n-95b61a19/"
        },
        {
          id: 8,
          name: "Arun S",
          role: "Innovation Expert",
          initialImg: "./images/Arun s(initial).jpg",
          linkedIn: "https://www.linkedin.com/in/arunsvenkat/"
        }
      ];
  return (<div className='teambody'>
    <div className="team-section">
      <h1 className="team-h1" style={{ color: "#023858" }}>Executive Team</h1>
      <div className="team-grid">
        {teamMembers.map((member) => (
          <Teammate key={member.id} {...member}/>
        ))}
      </div>
    </div>
    </div>
  )
}
